import $ from 'jquery';

$('.c-main-nav__link').on("touchstart", function (e) {
    
    'use strict'; //satisfy code inspectors
    
    var link = $(this); //preselect the link
    
    if (link.parent().hasClass('is-open')) {
        return true;
    } 
    
    else {
        link.parent().addClass('is-open');
        link.parent().siblings().removeClass('is-open');
        e.preventDefault();
        return false; //extra, and to make sure the function has consistent return points
    }
});